import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Subtitle = ({user, size = 'text-lg', uppercase = true, icon = false, children} ) => {
    // console.log(user);
    return (
        <>
            <h2 className={`${size} font-bold ${uppercase ? 'uppercase' : ''} bold`}>
                {icon && 
                    <FontAwesomeIcon className="text-mlime text-xl mr-2" icon={`${icon}`} />
                }
                {children}
            </h2>
            <hr className="border-mgray mt-3 mb-2" />
        </>

    )
}

export default Subtitle;